@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.bulk-error-or-warning {
  border-radius: 4px;
  box-shadow: 0 2px 2px @bulk-errors-and-warnings-modal--box-shadow-color;
  padding: 15px;

  &.error {
    background: @bulk-errors-and-warnings-modal--error--background-color;

    .error-indicator-name {
      color: @bulk-errors-and-warnings-modal--error--text-color;
    }

    .error-data {
      border-color: @bulk-errors-and-warnings-modal--error--border-color;
    }
  }

  &.warning {
    background: @bulk-errors-and-warnings-modal--warning--background-color;

    .error-indicator-name {
      color: @bulk-errors-and-warnings-modal--warning--text-color;
    }

    .error-data {
      border-color: @bulk-errors-and-warnings-modal--warning--border-color;
    }
  }
}

.error-header {
  display: flex;
  align-items: center;
}

.error-indicator {
  padding-right: 20px;
  white-space: nowrap;
}

.error-indicator-icon,
.error-indicator-name {
  display: inline-block;
  vertical-align: middle;
}

.error-indicator-icon {
  height: 35px;
  width: 35px;
}

.error-indicator-name {
  margin-left: 5px;
  line-height: 35px;
  font-size: 24px;
}

.error-data {
  padding-left: 20px;
  border-left: 1px solid transparent;
}

.error-description {
  font-size: 13px;
  color: @bulk-errors-and-warnings-modal--error-description--text-color;
  margin-bottom: 10px;
}

.error-actions {
  > button {
    position: relative;
    font-size: 14px;

    &:not(:first-child) {
      margin-left: 15px;
    }
    &:not(:last-child) {
      margin-right: 15px;
      &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: -15px;
        border-right: 1px solid @bulk-errors-and-warnings-modal--error-actions--border-color;
        opacity: 0.2;
      }
    }
  }
}

.expander-wrapper {
  width: 50px;
  min-width: 50px;
  padding-left: 20px;
}

.expander-button {
  height: 30px;
  width: 30px;
  transform: scale(0.3);
  cursor: pointer;

  &.expanded {
    > svg {
      transform: rotate(-180deg);
    }
  }

  &:hover {
    > svg {
      opacity: 1;
    }
  }

  > svg {
    height: 100%;
    width: 100%;
    fill: @bulk-errors-and-warnings-modal--error-expander--fill-color;
    opacity: 0.5;
  }
}

.error-body {
  margin-top: 15px;
}
